<template>
<div>
    <h1 class="mb-4 text-gray-500">Tnaflix Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with Tnaflix downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>

    <tnaflix-faq></tnaflix-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Tnaflix Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Tnaflix Downloader is a free Chrome extension that allows you to download videos from Tnaflix for offline viewing. Save videos in their original quality to watch anytime, anywhere.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does Tnaflix Downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Tnaflix Downloader uses a browser extension to detect video files on Tnaflix pages. Simply copy the video URL, paste it into our downloader interface, and the extension will extract the video file for download.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Is Tnaflix Downloader free?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, Tnaflix Downloader is completely free to use. There are no hidden fees, subscription plans, or usage limits. Install the extension and start downloading immediately.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'What browsers support Tnaflix Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Tnaflix Downloader works with Chrome, Edge, Brave, and other Chromium-based browsers. The extension is lightweight and doesn\'t slow down your browsing experience.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free Tnaflix Downloader - Download Videos from Tnaflix',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos from Tnaflix for free using our Chrome extension. Save videos in original quality for offline viewing. Works with Chrome, Edge, and Brave.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'tnaflix downloader, download tnaflix videos, tnaflix video downloader, free tnaflix downloader, tnaflix chrome extension'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/tnaflix-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>
